import React from 'react';

function HabitList(props) {
    const { habit, setHabit } = props;

    
    const handleClickRemove = (habitEntry) => {
        const habits = {...habit};
        
        delete habits[habitEntry];

        setHabit(habits);
    }

    const handleClickCheck = (e, habitEntry, day) => {
        const habits = {...habit};
        
        habits[habitEntry][day] = e.target.checked;

        setHabit(habits);
    }

    const isChecked = (key, day) => {
        const habits = {...habit};

        if (!habits[key][day]) {
            return false;
        }

        return habits[key][day];
    }

    if (habit) {
        return (
            <ul className="habit-list">
                {Object.keys(habit).map(h => (
                    <span className="habit-list-flex">
                        <li className="habit-list-item" key={h}>{habit[h].name}<button className="close-btn" onClick={() => { handleClickRemove(h) }}>x</button></li>
                        <span className="habit-check-list">
                            <label className="habit-check">
                                <input type="checkbox" className="monday" key={h} onChange={(e) => {handleClickCheck(e, h, 'monday')}} checked={isChecked(h, 'monday')}/>
                            </label>
                            <label className="habit-check">
                                <input type="checkbox" className="tuesday" key={h} onChange={(e) => {handleClickCheck(e, h, 'tuesday')}} checked={isChecked(h, 'tuesday')}/>
                            </label>
                            <label className="habit-check">
                                <input type="checkbox" className="wednesday" key={h} onChange={(e) => {handleClickCheck(e, h, 'wednesday')}} checked={isChecked(h, 'wednesday')}/>
                            </label>
                            <label className="habit-check">
                                <input type="checkbox" className="thursday" key={h} onChange={(e) => {handleClickCheck(e, h, 'thursday')}} checked={isChecked(h, 'thursday')}/>
                            </label>
                            <label className="habit-check">
                                <input type="checkbox" className="friday" key={h} onChange={(e) => {handleClickCheck(e, h, 'friday')}} checked={isChecked(h, 'friday')}/>
                            </label>
                            <label className="habit-check">
                                <input type="checkbox" className="saturday" key={h} onChange={(e) => {handleClickCheck(e, h, 'saturday')}} checked={isChecked(h, 'saturday')}/>
                            </label>
                            <label className="habit-check">
                                <input type="checkbox" className="sunday" key={h} onChange={(e) => {handleClickCheck(e, h, 'sunday')}} checked={isChecked(h, 'sunday')}/>
                            </label>
                        </span>
                    </span>
                ))}
            </ul>
        )
    }
}

export default HabitList;